import { render } from "./courseCollection.vue?vue&type=template&id=966d0522&scoped=true"
import script from "./courseCollection.vue?vue&type=script&lang=js"
export * from "./courseCollection.vue?vue&type=script&lang=js"

import "./courseCollection.vue?vue&type=style&index=0&id=966d0522&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-966d0522"]])

export default __exports__